var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 81,
    viewBox: "0 0 239 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7718 38.1169C87.8241 38.5209 88.7657 39.0673 89.5282 39.7637C90.2907 40.4948 90.9045 41.3721 91.3773 42.3609C91.8119 43.3498 92.0292 44.4464 92.0292 45.6545C92.0292 46.8627 91.8119 47.9246 91.3773 48.9096C90.9045 49.8985 90.2907 50.7757 89.5282 51.4721C88.7657 52.2032 87.8241 52.7534 86.7718 53.1536C85.6853 53.5576 84.5225 53.7769 83.2568 53.7769H70.5957V27.7975H89.818V32.8457H75.8874V37.5282H83.2568C84.5263 37.5321 85.6853 37.7168 86.7718 38.1169ZM85.9027 43.242C85.2126 42.6918 84.309 42.3993 83.1844 42.3993H75.8874V48.875H83.1844C84.309 48.875 85.2126 48.5826 85.9027 48.0323C86.5927 47.4821 86.9168 46.7165 86.9168 45.6545C86.9168 44.5926 86.5927 43.7884 85.9027 43.242Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.907 53.7769H96.838V27.7975H101.907V38.8095L110.923 27.7975H117.225L106.942 40.2754L119.371 53.7769H112.752L101.907 41.9954V53.7769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.16 53.1241C125.526 52.4291 124.109 51.4807 122.909 50.275C121.71 49.0693 120.767 47.6832 120.076 46.0398C119.384 44.3965 119.06 42.6456 119.06 40.7833C119.06 38.9211 119.388 37.1702 120.076 35.5269C120.767 33.8835 121.71 32.4589 122.909 31.2533C124.109 30.0476 125.526 29.0992 127.16 28.4043C128.795 27.7093 130.609 27.3829 132.572 27.3829C134.023 27.3829 135.44 27.6018 136.784 28.0395C138.128 28.5156 139.362 29.1338 140.489 29.9401C141.577 30.781 142.524 31.7294 143.322 32.8622C144.121 33.9949 144.701 35.2734 145.064 36.6595H139.362C139.106 36.003 138.743 35.4193 138.274 34.9086C137.8 34.398 137.258 33.9603 136.639 33.5955C136.02 33.2653 135.405 32.9734 134.714 32.793C134.023 32.6087 133.297 32.5012 132.572 32.5012C131.338 32.5012 130.211 32.7201 129.23 33.1232C128.214 33.5609 127.343 34.1445 126.614 34.9125C125.888 35.6804 125.342 36.5559 124.945 37.5427C124.544 38.5295 124.365 39.6238 124.365 40.791C124.365 41.9583 124.548 43.0564 124.945 44.0394C125.346 45.0262 125.888 45.9017 126.614 46.6696C127.34 47.4375 128.21 48.0212 129.23 48.4205C130.211 48.8582 131.338 49.0771 132.572 49.0771C133.297 49.0771 134.023 48.9657 134.714 48.7853C135.405 48.6009 136.02 48.3092 136.639 47.9444C137.258 47.6142 137.8 47.1764 138.274 46.6657C138.747 46.1551 139.11 45.5714 139.362 44.9148H145.064C144.701 46.301 144.121 47.545 143.322 48.6739C142.524 49.8066 141.581 50.7933 140.489 51.5958C139.362 52.4367 138.128 53.055 136.784 53.4965C135.44 53.9727 134.023 54.1914 132.572 54.1914C130.612 54.1838 128.795 53.8191 127.16 53.1241Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.01 54.1914V52.8253H159.057C162.277 52.8253 164.321 51.189 164.321 48.3517C164.321 45.5444 162.293 43.908 159.057 43.908H159.01V42.632H157.199V43.908H157.137C153.916 43.908 151.872 45.5444 151.872 48.3517C151.872 51.189 153.916 52.8253 157.137 52.8253H157.199V54.1914H159.01ZM157.199 51.219H157.137C154.768 51.219 153.715 50.0931 153.715 48.3517C153.715 46.6253 154.783 45.4843 157.137 45.4993H157.199V51.219ZM159.01 51.219V45.4993H159.072C161.41 45.4843 162.494 46.6253 162.494 48.3517C162.494 50.0781 161.426 51.219 159.072 51.219H159.01Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.488 53.9212C174.631 53.9212 177.17 51.4892 177.17 48.4117C177.17 45.3794 174.631 42.9022 171.488 42.9022C168.329 42.9022 165.805 45.3342 165.805 48.4117C165.805 51.4892 168.329 53.9212 171.488 53.9212ZM171.488 52.2248C169.305 52.2248 167.632 50.5134 167.632 48.4117C167.632 46.31 169.305 44.5986 171.488 44.5986C173.655 44.5986 175.328 46.31 175.328 48.4117C175.328 50.5134 173.655 52.2248 171.488 52.2248Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.89 43.1276C185.15 43.1276 186.699 44.6439 186.699 46.5652C186.699 48.5318 185.15 50.0481 182.89 50.0481H181.202V53.7411H179.391V43.1276H182.89ZM182.874 48.3967C184.175 48.3967 184.918 47.6011 184.918 46.5652C184.918 45.5294 184.175 44.779 182.874 44.779H181.202V48.3967H182.874Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.726 53.7411H195.337V52.0597H190.537V49.1773H194.408V47.5412H190.537V44.809H195.337V43.1276H188.726V53.7411Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.255 50.1681C217.713 52.2548 215.608 53.9212 212.96 53.9212C209.677 53.9212 207.231 51.5343 207.231 48.4117C207.231 45.2892 209.677 42.9022 212.96 42.9022C215.608 42.9022 217.713 44.5686 218.255 46.6553H216.304C215.84 45.4393 214.508 44.5986 212.96 44.5986C210.668 44.5986 209.058 46.265 209.058 48.4117C209.058 50.5585 210.668 52.2248 212.96 52.2248C214.508 52.2248 215.84 51.3841 216.304 50.1681H218.255Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.081 53.7607L201.841 48.3832L206.72 43.1276H204.425L200.258 47.6247H199.568V43.1276H197.757V53.7607H199.568V49.2117H200.258L204.704 53.7607H207.081Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9812 61C51.04 61 60.0049 52.0457 60.0049 41C60.0049 29.9543 51.04 21 39.9812 21C28.9224 21 19.9575 29.9543 19.9575 41C19.9575 52.0457 28.9224 61 39.9812 61Z",
    fill: "url(#paint0_linear_317_826)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0409 24.4152C22.3837 30.4636 23.1062 41.3612 30.6566 48.7531C38.2043 56.145 49.719 57.2366 56.3787 51.1856C57.1333 50.5 57.793 49.7523 58.3588 48.9545C59.418 46.5167 60.0051 43.8268 60.0051 41C60.0051 29.9543 51.0402 21 39.9815 21C36.2593 21 32.7744 22.0144 29.7886 23.7815C29.5332 23.9832 29.2838 24.1944 29.0409 24.4152Z",
    fill: "url(#paint1_radial_317_826)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4004 24.414C27.2495 29.207 30.9189 36.6557 38.5973 41.0465C46.2757 45.4399 55.0517 45.1139 58.2052 40.3182C59.0958 38.9639 59.4422 37.398 59.3079 35.7492C56.9989 27.2506 49.221 21 39.9814 21C37.1911 21 34.5341 21.5701 32.1208 22.5999C31.4411 23.1088 30.8607 23.7137 30.4004 24.414Z",
    fill: "url(#paint2_radial_317_826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_826",
    x1: 50.8001,
    y1: 85.859,
    x2: 37.1984,
    y2: -4.57742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303516,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733277,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_317_826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.9269 42.7105) rotate(106.278) scale(36.1876 30.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279744,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450971,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_317_826",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.7169 13.6694) rotate(53.1036) scale(50.7038 56.5649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136507,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397079,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725487,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForex);
export default __webpack_public_path__ + "static/media/forex.4a06203ab60f2bcadf66ae4f2149625e.svg";
export { ForwardRef as ReactComponent };